"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Tooltip_1 = __importDefault(require("../tooltip/Tooltip"));
var ContentHeader = function (props) {
    var children = props.children, classes = props.classes, maxCharacters = props.maxCharacters;
    if (maxCharacters && typeof children === 'string' && children.length > maxCharacters) {
        var truncatedText = children.substring(0, maxCharacters);
        return (react_1.default.createElement(Tooltip_1.default, { text: children },
            react_1.default.createElement("h4", { className: getClassNames(classes) }, truncatedText + "...")));
    }
    return (react_1.default.createElement("h4", { className: getClassNames(classes) }, children));
};
ContentHeader.defaultProps = {};
var getClassNames = function (classes) {
    return classnames_1.default('fds-list-item-content-header', 'all-y-margin-0', classes);
};
exports.default = ContentHeader;
